module.exports = __webpack_public_path__ + "img/outlook.77878575.svg";